import { QUERY_KEY } from 'constants/globalConstants'
import ApiService from 'apiService'
import { useQuery } from 'react-query'

const useNodeBarDetails = (id, nodeId) => {
    return useQuery(QUERY_KEY.NODE_BAR_DETAILS, () => ApiService.nodeBarDetails(id, nodeId), {retry: false})
}

export default useNodeBarDetails